/**
 * @description: 骨架屏
 */
import classNames from 'classnames';
import React from 'react';

import './index.scss';

interface rowsSetting {
  /** 宽度 */
  width?: number | string;
  /** 高度 */
  height?: number | string;
  /** 类型 */
  type?: 'square' | 'circle';
  style?: React.CSSProperties;
}
export interface ISkeleton {
  /** 类名 */
  className?: string;
  /** 自定义样式 */
  style?: React.CSSProperties;
  /** 行配置 */
  rows?: rowsSetting[];
}
const Skeleton = (props: ISkeleton) => {
  const { className = '', style = {}, rows = [] } = props;
  return (
    <div
      className={classNames('odc-skeleton', className)}
      style={style}
    >
      {
        rows.map((item, index) => {
          const { width = '100%', height = '32px', type = 'bar', style } = item;
          return (
            <div
              key={`odc_skeleton_item_${index}`}
              className={classNames('odc-skeleton-item', `odc-skeleton-${type}`)}
              style={{
                ...style,
                width,
                height,
              }}
            />
          );
        })
      }
    </div>
  );
};
export default Skeleton;
